export const routeProp = {
  methods: {
    routeProp (level, property) {
      if (this.$route.matched.length &&
        this.$route.matched[level] !== undefined &&
        this.$route.matched[level].props.default !== undefined &&
        this.$route.matched[level].props.default[property] !== undefined) {
        return this.$route.matched[level].props.default[property]
      } else return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/routeProp.js